// const API_URL = "http://localhost:8000/api/store/";
const API_URL = "https://sell.sidekicks.co.uk/api/store/";

let jobsData = {
  "part-time": [],
  "full-time": []
};

// Current active job type
let currentJobType = "part-time";

// Function to create a single job card HTML
function createJobCard(job) {
  const isOpen = job.status === "open";
  const buttonText = isOpen ? "APPLY NOW" : "CLOSED";
  const buttonClass = isOpen ? "job-apply-btn" : "job-apply-btn job-apply-btn-disabled";
  const buttonDisabled = isOpen ? "" : "disabled";
  const onClickHandler = isOpen ? `onclick="applyForJob('${job.apply_link}')"` : "";

  // Format work type display
  const workTypeDisplay = {
    'REMOTE': '🖥 REMOTE',
    'IN_PERSON': '🏪 IN PERSON',
    'HYBRID': '🚗 HYBRID'
  };

  return `
    <div class="job-card" data-job-id="${job.id}">
      <div class="job-header">
        <div class="job-title">${job.title}</div>
        <div class="job-salary">
          <span class="amount">${job.salary}</span>
          <span class="separator"> / </span>
          <span class="amount">${job.period}</span>
        </div>
      </div>
      <div class="job-badges">
        <span class="job-badge">🏴 ${job.location}</span>
        <span class="job-badge">${workTypeDisplay[job.work_type] || job.work_type}</span>
      </div>
      <p class="job-description">
        ${job.description}
      </p>
      <button class="${buttonClass}" ${buttonDisabled} ${onClickHandler}>${buttonText}</button>
    </div>
  `;
}

// Function to render jobs by type
function renderJobs(jobType = currentJobType) {
  const jobsGrid = document.querySelector('.jobs-grid');
  if (!jobsGrid) {
    console.error('Jobs grid container not found');
    return;
  }
  
  const jobs = jobsData[jobType] || [];
  
  if (jobs.length === 0) {
    // Show no jobs message
    const jobTypeDisplay = jobType === 'part-time' ? 'part-time' : 'full-time';
    jobsGrid.innerHTML = `
      <div style="grid-column: 1 / -1; text-align: center; padding: 60px 20px;">
        <div style="margin-bottom: 16px;">
          <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" style="opacity: 0.3;">
            <path d="M24 4C35.0457 4 44 12.9543 44 24C44 35.0457 35.0457 44 24 44C12.9543 44 4 35.0457 4 24C4 12.9543 12.9543 4 24 4ZM24 8C15.1634 8 8 15.1634 8 24C8 32.8366 15.1634 40 24 40C32.8366 40 40 32.8366 40 24C40 15.1634 32.8366 8 24 8ZM24 14C25.1046 14 26 14.8954 26 16V24C26 25.1046 25.1046 26 24 26C22.8954 26 22 25.1046 22 24V16C22 14.8954 22.8954 14 24 14ZM24 30C25.1046 30 26 30.8954 26 32C26 33.1046 25.1046 34 24 34C22.8954 34 22 33.1046 22 32C22 30.8954 22.8954 30 24 30Z" fill="#657186"/>
          </svg>
        </div>
        <h3 style="color: #1e1e1e; font-size: 18px; font-family: 'Archivo', Helvetica; font-weight: 500; margin-bottom: 8px; letter-spacing: -0.56px;">
          No ${jobTypeDisplay} positions available
        </h3>
        <p style="color: #808080; font-size: 15px; font-family: 'Archivo', Helvetica; font-weight: 500; line-height: 22px; letter-spacing: -0.30px; max-width: 400px; margin: 0 auto;">
          We don't have any ${jobTypeDisplay} openings at the moment, but we're always looking for great talent. Check back soon or try the other job type!
        </p>
      </div>
    `;
  } else {
    // Render jobs normally
    jobsGrid.innerHTML = jobs.map(job => createJobCard(job)).join('');
  }
}

// Function to filter jobs by type and update toggle appearance
function filterJobs(type) {
  currentJobType = type;
  renderJobs(type);
  updateToggleAppearance(type);
}

// Function to update toggle button appearance
function updateToggleAppearance(activeType) {
  const toggleContainer = document.querySelector('.toggle-container');
  if (!toggleContainer) return;
  
  const buttons = toggleContainer.querySelectorAll('button');
  
  buttons.forEach(button => {
    const isPartTime = button.dataset.type === 'part-time' || button.textContent.includes('Part Time');
    const isActive = (activeType === 'part-time' && isPartTime) || (activeType === 'full-time' && !isPartTime);
    
    if (isActive) {
      button.classList.remove('toggle-text-inactive');
      button.classList.add('toggle-active');
    } else {
      button.classList.remove('toggle-active');
      button.classList.add('toggle-text-inactive');
    }
  });
}

// Function to handle job application
function applyForJob(applyLink) {
  if (applyLink && applyLink.trim() !== '') {
    // Open the apply link in a new tab/window
    window.open(applyLink, '_blank');
  } else {
    // Fallback if no apply link is provided
    alert('Sorry, the application link is not available at the moment. Please try again later.');
  }
}

// Function to load jobs from backend
async function loadJobsFromBackend() {
  try {
    console.log('Loading jobs from backend...');
    const response = await fetch(API_URL + 'jobs/');
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    const result = await response.json();
    
    if (result.success && result.data) {
      console.log('Jobs loaded successfully:', result);
      
      // Transform the data to match our frontend structure
      const transformedData = {
        "part-time": result.data.part_time || [],
        "full-time": result.data.full_time || []
      };
      
      return transformedData;
    } else {
      console.error('API returned unsuccessful response:', result);
      throw new Error(result.message || 'Failed to load jobs');
    }
    
  } catch (error) {
    console.error('Error loading jobs from backend:', error);
    
    // Return empty data structure on error
    return { "part-time": [], "full-time": [] };
  }
}

// Initialize jobs when the page loads
document.addEventListener('DOMContentLoaded', async function() {
  try {
    // Load jobs from backend
    const jobs = await loadJobsFromBackend();
    
    // Update global jobsData
    jobsData = jobs;
    
    // Render initial part-time jobs
    renderJobs(currentJobType);
    
    // Set up toggle functionality with individual button listeners
    const toggleContainer = document.querySelector('.toggle-container');
    
    if (toggleContainer) {
      const buttons = toggleContainer.querySelectorAll('button');
      
      buttons.forEach((button) => {
        button.addEventListener('click', (e) => {
          e.preventDefault();
          
          const jobType = button.dataset.type;
          if (jobType) {
            filterJobs(jobType);
          }
        });
      });
    }
    
    // Set initial toggle appearance
    updateToggleAppearance(currentJobType);
    
  } catch (error) {
    console.error('Error initializing jobs:', error);
    
    // Show error message to user
    const jobsGrid = document.querySelector('.jobs-grid');
    if (jobsGrid) {
      jobsGrid.innerHTML = `
        <div style="grid-column: 1 / -1; text-align: center; padding: 40px;">
          <p style="color: #808080; font-size: 16px;">Sorry, we're having trouble loading job postings right now. Please try again later.</p>
        </div>
      `;
    }
  }
});

// Function to scroll to jobs section
function scrollToJobs() {
  const jobsSection = document.getElementById('open-positions');
  if (jobsSection) {
    jobsSection.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  }
}

// Export functions for potential use in other files
if (typeof module !== 'undefined' && module.exports) {
  module.exports = {
    renderJobs,
    filterJobs,
    loadJobsFromBackend,
    applyForJob,
    scrollToJobs,
    jobsData
  };
}
